import React from 'react'
import _ from 'lodash'

import {
    TextField,
    ReferenceField,
    NumberField,
    EmailField,
    BooleanField,
    DateField,
    ReferenceLinkField,
    StatusField,
    ValidadoField,
} from '../Fields'

import { SingleFieldList, ChipField, ReferenceArrayField } from 'react-admin'



const fieldMappings = {
    string: TextField,
    email: EmailField,
    number: NumberField,
    boolean: BooleanField,
    date: DateField,
    status : StatusField,
    validado : ValidadoField,
}

const renderField = (permissions) => (field) => {
    if (!!field.roles && !field.roles.includes(permissions.role)) {
        return null
    }

    // TODO: add 'roles' key to fields in shapes
    if (field.source === "status") {
        return null
    }

    // if (field.source === "validacionbbdd") {
    //     return null
    // }

    // if (field.source === "validacionactivos") {
    //     return null
    // }

    if (field.source === "validacionbbdd" || field.source === "validacionactivos" ) {

        const Component = ({ source, record = {} }) => {
            if (record[source] == 1){
                return <img src="/images/parametro_aprobado_small.png"/>
            }
            else if (record[source] == 2){    
                return <img src="/images/parametro_rechazado_small.png"/>
            }
            else if (record[source] == 3){    
                return <img src="/images/parametro_en_uso_small.png"/>
            }
            else{
                return <span>{""}</span>
            }
                
        }
        return <Component key={field.source} {...field} />
    }
    
    if (field.type === "referenceLink") {
        return (
            <ReferenceLinkField
                key={field.reference}
                source={""}
                label={field.label}
                sourceFields={field.sourceFields}
                reference={field.reference}
            />
        )
    }
    else if (field.type === "reference") {
        const ChildComponent = fieldMappings[field.targetType]
        return (
            <ReferenceField
                key={field.source}
                reference={field.reference}
                source={field.source}
            >
                <ChildComponent source={field.targetSource} />
            </ReferenceField>
        )
    }
    else if (field.type === "referenceMany") {
        return (
            <ReferenceArrayField 
                key={field.source} 
                label={field.label} 
                reference={field.reference} 
                source={field.source}
            >
                <SingleFieldList>
                    <ChipField source={field.targetSource} />
                </SingleFieldList>
            </ReferenceArrayField>
        )
    }
    
    const Component = fieldMappings[field.type]
    return <Component key={field.source} {...field} />
}

export const renderModelFields = (fields, permissions) => _.map(fields, renderField(permissions))
